import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const LiveStatsBar = () => {
  const [stats, setStats] = useState({
    activePlayers: 12847,
    liveGames: 156,
    todayWinners: 2341,
    totalPayout: 45678900
  });

  const [recentWinners] = useState([
    { name: "Rajesh K.", amount: 125000, game: "Teen Patti", time: "2 min ago" },
    { name: "Priya S.", amount: 89000, game: "Andar Bahar", time: "5 min ago" },
    { name: "Amit P.", amount: 156000, game: "Cricket Betting", time: "8 min ago" },
    { name: "Sneha M.", amount: 67000, game: "Roulette", time: "12 min ago" },
    { name: "Vikram R.", amount: 234000, game: "Blackjack", time: "15 min ago" }
  ]);

  const [currentWinnerIndex, setCurrentWinnerIndex] = useState(0);

  useEffect(() => {
    // Simulate live stats updates
    const interval = setInterval(() => {
      setStats(prev => ({
        ...prev,
        activePlayers: prev?.activePlayers + Math.floor(Math.random() * 10) - 5,
        liveGames: prev?.liveGames + Math.floor(Math.random() * 4) - 2,
        todayWinners: prev?.todayWinners + Math.floor(Math.random() * 3),
        totalPayout: prev?.totalPayout + Math.floor(Math.random() * 50000)
      }));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Cycle through recent winners
    const interval = setInterval(() => {
      setCurrentWinnerIndex((prev) => (prev + 1) % recentWinners?.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [recentWinners?.length]);

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(amount);
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-IN')?.format(num);
  };

  return (
    <div className="bg-gradient-royal text-white shadow-royal">
      {/* Main Stats Bar */}
      <div className="px-4 py-3">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          {/* Live Stats */}
          <div className="hidden lg:flex items-center space-x-8">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <Icon name="Users" size={16} />
              <span className="text-sm font-medium">
                {formatNumber(stats?.activePlayers)} Online
              </span>
            </div>
            
            <div className="flex items-center space-x-2">
              <Icon name="Gamepad2" size={16} />
              <span className="text-sm font-medium">
                {stats?.liveGames} Live Games
              </span>
            </div>
            
            <div className="flex items-center space-x-2">
              <Icon name="Trophy" size={16} />
              <span className="text-sm font-medium">
                {formatNumber(stats?.todayWinners)} Winners Today
              </span>
            </div>
            
            <div className="flex items-center space-x-2">
              <Icon name="IndianRupee" size={16} />
              <span className="text-sm font-medium">
                {formatAmount(stats?.totalPayout)} Paid Out
              </span>
            </div>
          </div>

          {/* Mobile Stats - Simplified */}
          <div className="flex lg:hidden items-center space-x-4">
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-sm font-medium">
                {formatNumber(stats?.activePlayers)} Online
              </span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Trophy" size={14} />
              <span className="text-sm font-medium">
                {formatNumber(stats?.todayWinners)} Winners
              </span>
            </div>
          </div>

          {/* Recent Winner Ticker */}
          <div className="flex items-center space-x-3">
            <div className="hidden sm:flex items-center space-x-2 bg-white/10 rounded-button px-3 py-1">
              <Icon name="Zap" size={14} color="gold" />
              <span className="text-sm font-medium">Latest Win:</span>
            </div>
            
            <div className="flex items-center space-x-2 animate-pulse-golden">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                <Icon name="Crown" size={14} color="gold" />
              </div>
              <div className="hidden sm:block">
                <p className="text-sm font-bold">
                  {recentWinners?.[currentWinnerIndex]?.name}
                </p>
                <p className="text-xs opacity-90">
                  {formatAmount(recentWinners?.[currentWinnerIndex]?.amount)} • {recentWinners?.[currentWinnerIndex]?.game}
                </p>
              </div>
              <div className="sm:hidden">
                <p className="text-sm font-bold">
                  {formatAmount(recentWinners?.[currentWinnerIndex]?.amount)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Scrolling Ticker - Mobile Only */}
      <div className="lg:hidden bg-black/20 py-2 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap">
          <span className="text-xs mx-4">
            🎉 Congratulations to all today's winners! 
          </span>
          {recentWinners?.map((winner, index) => (
            <span key={index} className="text-xs mx-4">
              {winner?.name} won {formatAmount(winner?.amount)} in {winner?.game} • 
            </span>
          ))}
        </div>
      </div>
      {/* Trust Indicators */}
      <div className="bg-black/20 px-4 py-2">
        <div className="flex items-center justify-center space-x-6 max-w-7xl mx-auto">
          <div className="flex items-center space-x-1">
            <Icon name="Shield" size={14} />
            <span className="text-xs">100% Secure</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={14} />
            <span className="text-xs">24/7 Support</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Zap" size={14} />
            <span className="text-xs">Instant Payouts</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Award" size={14} />
            <span className="text-xs">Licensed & Regulated</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveStatsBar;